import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

export function PageHead({ title, sub, actions }: { title: string; sub?: ReactNode; actions?: ReactNode }) {
  return (
    <header className="ph">
      <div>
        <h1>{title}</h1>
        {sub && <p>{sub}</p>}
      </div>
      {actions && <div className="ph-actions">{actions}</div>}
    </header>
  );
}

export function todayLine(): string {
  const d = new Date();
  const s = d.toLocaleDateString('ru-RU', {
    timeZone: 'Asia/Tashkent',
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
  const t = d.toLocaleTimeString('ru-RU', { timeZone: 'Asia/Tashkent', hour: '2-digit', minute: '2-digit' });
  return `${s.charAt(0).toUpperCase()}${s.slice(1)} · ${t} по Ташкенту`;
}

/** Вкладки раздела «Офферы»: сами офферы и их лендинги (в меню — один пункт, DESIGN §4). */
export function OfferTabs({ active }: { active: '/offers' | '/landings' }) {
  return (
    <nav className="tabs" aria-label="Офферы и лендинги">
      <Link to="/offers" aria-current={active === '/offers' ? 'page' : undefined}>
        Офферы
      </Link>
      <Link to="/landings" aria-current={active === '/landings' ? 'page' : undefined}>
        Лендинги
      </Link>
    </nav>
  );
}
